import React, { useState } from "react";
import { toast } from "react-toastify";
import Input from "components/Input";
import Button from "components/Button";
import ButtonInverted from "components/ButtonInverted";
import {
  BackDrop,
  Container,
  Header,
  Title,
  Footer,
  CloseButton,
  InputGroup,
  Label,
} from "./styles";

function parseScreeningType(value) {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
}

function DuplicateFormModal({
  selectedItem,
  bffService,
  buildStructure,
  validateFormStructure,
  onClose,
  onSuccess,
}) {
  const [name, setName] = useState(`${selectedItem.name} Cópia`);
  const [version, setVersion] = useState(selectedItem.version);
  const [saving, setSaving] = useState(false);

  const handleSubmit = () => {
    if (!name.trim() || !version.trim()) {
      toast.error("Informe nome e versão para duplicar o formulário.");
      return;
    }

    const duplicatedValues = {
      ...selectedItem,
      name: name.trim(),
      version: version.trim(),
      isCurrent: false,
    };

    const invalidStructureError = validateFormStructure(duplicatedValues);
    if (invalidStructureError) {
      toast.error(invalidStructureError);
      return;
    }

    setSaving(true);
    bffService
      .createForm({
        name: name.trim(),
        description: selectedItem.description || null,
        version: version.trim(),
        screeningType: parseScreeningType(selectedItem.screeningType),
        isCurrent: false,
        structure: buildStructure(duplicatedValues),
      })
      .then(() => {
        toast.success("Formulário duplicado com sucesso!");
        onSuccess();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Falha ao duplicar formulário");
      })
      .finally(() => setSaving(false));
  };

  return (
    <BackDrop>
      <Container>
        <Header>
          <Title>Duplicar formulário</Title>
          <CloseButton onClick={onClose}>×</CloseButton>
        </Header>

        <InputGroup>
          <Label>Nome</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} />
        </InputGroup>

        <InputGroup>
          <Label>Versão</Label>
          <Input value={version} onChange={(e) => setVersion(e.target.value)} />
        </InputGroup>

        <Footer>
          <ButtonInverted label="Cancelar" onClick={onClose} />
          <Button label={saving ? "Salvando..." : "Duplicar"} onClick={handleSubmit} disabled={saving} />
        </Footer>
      </Container>
    </BackDrop>
  );
}

export default DuplicateFormModal;
